var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg006Cube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.2,
    height: 48,
    viewBox: "0 0 43.2 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_006-cube",
    "data-name": "006-cube",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80186",
    "data-name": "Path 80186",
    d: "M24.6,21.2,3,11.6,24.6,2l21.6,9.6Z",
    transform: "translate(0 0)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(3 16.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80187",
    "data-name": "Path 80187",
    d: "M22.2,17.6,3,8V32l19.2,9.6Z",
    transform: "translate(-3 -8)",
    fill: "#3bbf83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80188",
    "data-name": "Path 80188",
    d: "M32.2,32V8L13,17.6v24Z",
    transform: "translate(11 -8)",
    fill: "#12784a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg006Cube);
export default __webpack_public_path__ + "static/media/006-cube.53ca29003f5adac362a87d99e969ec3c.svg";
export { ForwardRef as ReactComponent };